// extracted by mini-css-extract-plugin
export var actions = "_4p-0";
export var actionsContainer = "_4p-7";
export var border = "_4p-1";
export var childFullHeight = "_4p-f";
export var collapse = "_4p-2";
export var content = "_4p-a";
export var contentChild = "_4p-e";
export var fullscreen = "_4p-c";
export var hasLeftRadius = "_4p-k";
export var headerContainer = "_4p-3";
export var headerRow = "_4p-5";
export var hidePadding = "_4p-b";
export var navCollapsedGap = "_4p-l";
export var noScrollX = "_4p-m";
export var noScrollY = "_4p-n";
export var noTopPadding = "_4p-i";
export var optOutTopPadding = "_4p-d";
export var pageMain = "_4p-j";
export var pageOuter = "_4p-g";
export var pagePadding = "_4p-8";
export var pageScroll = "_4p-9";
export var profile = "_4p-o";
export var profileContainer = "_4p-p";
export var profileImage = "_4p-q";
export var profileMain = "_4p-r";
export var profileSubtitle = "_4p-t";
export var profileTitle = "_4p-s";
export var showLeftPadding = "_4p-h";
export var tabsPortalSlot = "_4p-6";
export var tabsWrapper = "_4p-4";
export var title = "_4p-u";